var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuseRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.6875C7 8.1849 7 7.4336 7.4668 6.9668C7.9336 6.5 8.6849 6.5 10.1875 6.5C11.6901 6.5 12.4414 6.5 12.9082 6.9668C13.375 7.4336 13.375 8.1849 13.375 9.6875V20.3125C13.375 21.8151 13.375 22.5664 12.9082 23.0332C12.4414 23.5 11.6901 23.5 10.1875 23.5C8.6849 23.5 7.9336 23.5 7.4668 23.0332C7 22.5664 7 21.8151 7 20.3125V9.6875Z",
    stroke: "#1E1F26",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6246 9.6875C17.6246 8.1849 17.6246 7.4336 18.0913 6.9668C18.5582 6.5 19.3095 6.5 20.8121 6.5C22.3147 6.5 23.066 6.5 23.5328 6.9668C23.9996 7.4336 23.9996 8.1849 23.9996 9.6875V20.3125C23.9996 21.8151 23.9996 22.5664 23.5328 23.0332C23.066 23.5 22.3147 23.5 20.8121 23.5C19.3095 23.5 18.5582 23.5 18.0913 23.0332C17.6246 22.5664 17.6246 21.8151 17.6246 20.3125V9.6875Z",
    stroke: "#1E1F26",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuseRecording);
export default __webpack_public_path__ + "static/media/puse-recording.f93e5d814564c5922a8c163ba141e42b.svg";
export { ForwardRef as ReactComponent };